import { Box, Typography, styled } from '@mui/material'

export const MainHeading = styled(Typography)({
  color: 'common.black',
  fontSize: '2rem',
  fontWeight: 700,
  margin: '.5rem .5rem 1.25rem',
})

export const NoAssetPlaceholder = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  textAlign: 'center',
  color: theme.palette.grey[600],
  margin: '20px 8px 0',
}))

export const AssetDocumentCard = styled(Box)(({ theme }) => ({
  maxWidth: '210px',
  minHeight: '120px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '15px',
  border: `2px solid ${theme.palette.grey['500']}`,
  backgroundColor: theme.palette.common.white,
  color: 'grey.500',

  '> svg': {
    fontSize: '4rem',
    color: 'rgb(48, 39, 128)',
  },

  '> svg, > p': {
    margin: '8px 0',
  },
}))

export const AssetImgCard = styled(Box)(({ theme }) => ({
  width: '340px',
  height: '207px',
  overflow: 'hidden',
  background: theme.palette.common.white,
  borderRadius: '15px',
  border: `5px solid ${theme.palette.grey['400']}`,
  position: 'relative',

  img: {
    width: '100%',
    height: '100%',
  },
}))

export const AssetImgCardOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  border: 0,
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1.25rem',
  color: theme.palette.common.white,
  backgroundColor: 'rgba(0, 0, 0, .5)',
  transition: 'top 0.3s ease',

  '> svg': {
    fontSize: '2rem',
    marginRight: '.25rem',
  },
}))

export const AssetContainer = styled('div')({
  maxWidth: '340px',
  margin: '10px auto',
  textAlign: 'center',
  'a:hover .downloadOverlay': {
    top: 0,
  },
  'a:focus .downloadOverlay': {
    top: 0,
  },
})
export const HeaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  minHeight: '5rem',
  margin: '0 .5rem',
  borderBottom: `1px solid #eee`,
})
